import React from 'react'
import { of } from 'rxjs'
import connect from 'front-end-core/decorators/connect'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import { ALL_FLAVOURS } from 'constants/flavours'
import { requestCommentsReference } from 'services/CommentsReferenceService'
import CommentsComponentContainer from 'redux/containers/pages/comments/CommentsComponentContainer'
import ResponseConsumer from 'components/shared/ResponseConsumer'

const Comments = (props) => (
  <ResponseConsumer
    response={props.filteredComments}
    content={() => (
      <CommentsConsumer {...props} />
    )}
  />
)

const CommentsConsumer = connect(({ filteredComments, category: _category, flavour }) => {
  const isQa = ALL_FLAVOURS.includes(_category)
  const category = isQa ? 'qa' : _category

  return {
    comments: requestCommentsReference({ flavour, category, comments: filteredComments }),
    category: of(category),
    isQa: of(isQa)
  }
})(props => {
  const comments = props.comments ?? RESPONSE_PENDING

  return (
    <ResponseConsumer
      response={comments}
      content={() => (
        <CommentsComponentContainer {...props} />
      )}
    />
  )
})

export default Comments
